var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12 2.44772 12.4477 2 13 2H19C19.5523 2 20 2.44772 20 3V5.25H12V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 6.75H20.375L21.5777 9.15542C21.8554 9.71084 22 10.3233 22 10.9443V20C22 21.1046 21.1046 22 20 22H12C10.8954 22 10 21.1046 10 20V19H16C16.5523 19 17 18.5523 17 18V14C17 13.4477 16.5523 13 16 13H10V10.9443C10 10.3233 10.1446 9.71084 10.4223 9.15542L11.625 6.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52398 13.4154C6.07734 13.1514 5.55636 13 5 13C3.34315 13 2 14.3431 2 16C2 16.5564 2.15145 17.0773 2.41536 17.524L6.52398 13.4154Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47601 18.5846C3.92265 18.8486 4.44363 19 4.99999 19C6.65684 19 7.99999 17.6569 7.99999 16C7.99999 15.4436 7.84854 14.9227 7.58463 14.476L3.47601 18.5846Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31374 2.68629C8.39868 1.77124 6.91508 1.77124 6.00003 2.68629L4.94214 3.74418C5.42786 5.31926 6.60033 6.58659 8.11354 7.20019L9.31374 6C10.2288 5.08494 10.2288 3.60135 9.31374 2.68629Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98323 8.33049C5.55703 7.59709 4.41931 6.38804 3.77651 4.90979L2.68629 6.00001C1.77124 6.91506 1.77124 8.39866 2.68629 9.31372C3.60135 10.2288 5.08494 10.2288 6 9.31372L6.98323 8.33049Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/medicine.960f82f5c53383bb4e0ac2a5cbe34b2f.svg";
export { ForwardRef as ReactComponent };